module.exports = __webpack_public_path__ + "img/decline.0422987f.svg";